import { useState } from "react";
import { Check, ChevronDown, CreditCard } from "lucide-react";
import { formatPrice } from "@/lib/store";
import { installmentFor, useRates } from "@/lib/pricing";

export const CASH = "avista";
const COUNTS = Array.from({ length: 21 }, (_, i) => i + 1);

// Texto do pagamento escolhido para a diferença (vai na mensagem do WhatsApp).
export const diffPayText = (amount, pick) => {
  if (!(amount > 0) || !pick) return "";
  if (pick === CASH) return `à vista no Pix ou dinheiro (${formatPrice(amount)})`;
  const { each, total } = installmentFor(amount, pick);
  return pick === 1 ? `1x no cartão (${formatPrice(total)})` : `${pick}x de ${formatPrice(each)} no cartão (total ${formatPrice(total)})`;
};

const Row = ({ active, onClick, testid, label, hint, value }) => (
  <button type="button" role="radio" aria-checked={active} data-testid={testid} onClick={onClick}
    className={`flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm transition-colors ${active ? "bg-[#25D366]/15 ring-1 ring-[#25D366]" : "hover:bg-white/[0.06]"}`}>
    <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${active ? "border-[#25D366] bg-[#25D366] text-black" : "border-white/30"}`}>
      {active && <Check className="h-2.5 w-2.5" strokeWidth={3} />}
    </span>
    <span className="shrink-0 text-zinc-300">{label}</span>
    <span className="min-w-0 flex-1 truncate text-right text-xs text-zinc-400">{hint}</span>
    <span className="shrink-0 font-semibold text-white">{value}</span>
  </button>
);

// Simulação de parcelas da diferença (taxas da maquininha do painel). O cliente escolhe e vai no pedido.
export const TradeInstallments = ({ amount, pick, onPick }) => {
  const [open, setOpen] = useState(false);
  useRates();
  if (!(amount > 0)) return null;
  const card = (n) => {
    const { each, total } = installmentFor(amount, n);
    return { value: formatPrice(each), hint: `total ${formatPrice(total)}` };
  };
  return (
    <div data-testid="trade-installments" className="mt-3 rounded-2xl border border-white/10 p-3">
      <p className="flex items-center gap-2 px-1 text-xs font-semibold uppercase tracking-[0.16em] text-zinc-300"><CreditCard className="h-3.5 w-3.5" /> Pagar a diferença</p>
      <div role="radiogroup" className="mt-2 space-y-0.5">
        <Row active={pick === CASH} onClick={() => onPick(CASH)} testid="trade-pay-cash" label="À vista" hint="Pix ou dinheiro" value={formatPrice(amount)} />
        <Row active={pick === 12} onClick={() => onPick(12)} testid="trade-pay-12x" label="12x de" {...card(12)} />
      </div>
      <button type="button" data-testid="trade-installments-toggle" onClick={() => setOpen((v) => !v)} className="mt-1 flex w-full items-center justify-center gap-1.5 py-1.5 text-xs font-semibold text-zinc-300 hover:text-white">
        {open ? "Esconder parcelas" : "Ver todas as parcelas (1x a 21x)"} <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-lenis-prevent data-testid="trade-installments-list" role="radiogroup" className="max-h-64 space-y-0.5 overflow-y-auto">
          {COUNTS.map((n) => (
            <Row key={n} active={pick === n} onClick={() => onPick(n)} testid={`trade-pay-${n}x-row`} label={n === 1 ? "1x no crédito" : `${n}x de`} {...card(n)} />
          ))}
        </div>
      )}
      <p className="mt-1 px-1 text-xs text-zinc-400">{pick ? "Essa forma de pagamento vai no seu pedido do WhatsApp." : "Toque numa opção para ela ir no seu pedido do WhatsApp."} Cartão de crédito, valores confirmados pela loja.</p>
    </div>
  );
};
